module.exports = __webpack_public_path__ + "static/media/51-iveco.3c4b8337.jpg";